<template>
  <!-- Header card/row -->
  <v-card
    :elevation="elevation"
    :rounded="cardRounded"
    class="d-flex justify-space-between py-4 px-3"
    :class="{
      'flex-column': $vuetify.breakpoint.xs,
      'align-center px-6': !$vuetify.breakpoint.xs,
    }"
  >
    <div
      class="d-flex pa-0"
      :style="$vuetify.breakpoint.width <= 1035 ? { 'max-width': '330px' } : {}"
    >
      <v-icon
        :large="!isMobile"
        dark
        class="pa-2 mr-4 my-2 rounded icon"
        :class="`${iconColor}-background`"
        >{{ icon }}</v-icon
      >
      <Typography :variant="titleVariant" class="my-auto text-left">{{ title }}</Typography>
    </div>
    <div
      v-if="showSearch"
      class="py-3 flex-grow-1"
      :class="
        $vuetify.breakpoint.md
          ? 'px-8'
          : $vuetify.breakpoint.lg || $vuetify.breakpoint.xl
          ? 'px-12'
          : 'px-auto'
      "
    >
      <!------------ Search Bar -------------->
      <template>
        <v-text-field
          outlined
          placeholder="Search"
          single-line
          dense
          hide-details
          v-model="debounceSearch"
          class="shrink mx-auto"
          append-icon="mdi-magnify"
          :style="isMobile ? '' : 'max-width: 450px;'"
          clearable
          color="brandCyan"
        ></v-text-field>
      </template>
      <!------------ End Search Bar -------------->
    </div>
    <div
      class="d-flex"
      :class="
        $vuetify.breakpoint.xs
          ? 'px-0'
          : $vuetify.breakpoint.md
          ? 'px-4 flex-grow-1'
          : $vuetify.breakpoint.lg || $vuetify.breakpoint.xl
          ? 'px-12 flex-grow-1'
          : 'px-8 flex-grow-1'
      "
      :style="
        $vuetify.breakpoint.xs
          ? { height: 'fit-content', 'max-width': '430px' }
          : { height: 'fit-content', 'max-width': '440px' }
      "
      v-if="hasPermissionToViewClients() && showClientDropdown"
    >
      <ClientDropdown class="my-auto full-width"></ClientDropdown>
      <Button v-if="showAddClient" class="ml-4" @click="handleAddClientClick">
        Create Client
      </Button>
    </div>
  </v-card>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import ClientDropdown from "@/components/ClientDropdown.vue";

import { mapState, mapGetters } from "vuex";
import { debounce } from "@/shared_data/functions";

import isMobile from "@/mixins/isMobile";

export default {
  name: "Header",
  components: {
    ClientDropdown,
    Button,
    Typography,
  },
  mixins: [isMobile],
  props: {
    title: {
      type: String,
      required: true,
    },
    titleVariant: {
      type: String,
      default: "h-2",
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "primary",
    },
    elevation: {
      type: Number,
      default: 0,
    },
    cardRounded: {
      type: String,
      default: "lg",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showAddClient: {
      type: Boolean,
      default: false,
    },
    showClientDropdown: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: null,
      debounceSearch: null,
    };
  },
  methods: {
    handleAddClientClick() {
      this.$emit("add-client");
    },
  },
  computed: {
    ...mapState(["globalClientId"]),
    ...mapGetters(["hasPermissionToViewClients"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
  },
  watch: {
    debounceSearch: debounce(function (newVal) {
      this.search = newVal;
      this.$emit("update-search", newVal);
    }, 500),
  },
};
</script>
